export default "__VITE_ASSET__111cf1dd__"